import { number } from "prop-types"
import updatePropertyList from './UpdatePropertyList/UpdatePropertyList'
import { distance } from '../../PropertySearch/Utility/Utility'
import { getMessageStatus } from '../Services/PropertyListService'
// import React from 'react'
let propertyList = {}
let unitMixRecords = []
let source = ''
let propertyId = ''

export function multitotalDataCountExt(prop1, prop2, symb, unitMixRecordsParam) {
    unitMixRecords = unitMixRecordsParam
    // console.log(' unitMixRecordsParam =', unitMixRecordsParam)
    return multitotalDataCount(prop1, prop2, symb, false)
}

export function multitotalDataCount(prop1, prop2, symb, avg) {
    try {

        let rentCount = unitMixRecords.length
        let equation = 0
        let total = 0

        for (let i = 0; i < unitMixRecords.length; i++) {
            let rentData = unitMixRecords[i]

            let a = rentData[prop1]
            let item1 = Number.parseFloat(a)

            a = rentData[prop2]
            let item2 = Number.parseFloat(a)

            if (symb === '*') {
                equation = (item1 * item2)
            }
            else if (symb === '/' && item2 !== 0) {
                if (HasValue(item1, item2)) {
                    equation = (item1 / item2)
                }
            }
            else if (symb === '+') {
                equation = (item1 + item2)
            }
            if (equation !== 0 && equation) {
                total = total + equation
            }
            else {
                rentCount--
            }
        }
        if (avg) {
            total = total <= 0 ? 0 : (total / rentCount)
        }
        return total
    }
    catch (e) /* istanbul ignore next */ {
        console.log(' Error in multitotalDataCount : ==> ' + e)
        return 0
    }
}

export function totalDataCountExt(prop1, unitMixRecordsParam, sourceParam, avg = false) {
    unitMixRecords = unitMixRecordsParam
    source = sourceParam
    return totalDataCount(prop1, avg)
}

function totalDataCount(prop1, avg = false) {
    try {

        let total = 0
        let count = 0
        let rentCount = unitMixRecords.length

        for (let i = 0; i < unitMixRecords.length; i++) {
            let rentData = unitMixRecords[i]
            if (rentData.source === source) {
                let a = rentData[prop1]

                let item1 = Number.parseFloat(a)

                if (item1 && item1 !== 0) {
                    total = total + item1
                    count++
                }
                else {
                    rentCount--
                }
            }
        }

        if (avg && count > 0) {
            total = total <= 0 ? 0 : (total / count)
        }

        return total
    }
    catch (e) /* istanbul ignore next */ {
        console.log(' Error in totalDataCount : ==> ' + e)
        return 0
    }
}

function totalDataCountExcludingItem(prop, avg, item) {
    var total = 0;
    var count = 0;

    unitMixRecords.forEach(val => {
        if (isUndefinedOrNull(val[item]) != '') {
            if (Number.parseFloat(val[prop])) {
                total = total + Number.parseFloat(val[prop])
                count++
            } else {
                length = length - 1
            }
        }
    })

    // forEach(listConInfo.rentData, function (val, i) {
    //     if (propId == val['PropertyID'] && val['source'] == _source && isUndefinedOrNull(val[item]) != '') {
    //         if (parseFloat(val[prop])) {
    //             total = total + parseFloat(val[prop])
    //             count++
    //         } else {
    //             length = length - 1
    //         }
    //     }
    // })

    if (avg && count > 0) {
        total = total <= 0 ? total / count : (total / count).toFixed(2)
    } else {
        total = parseInt(total)
    }

    return total
}


export function HasValue(a, b) {
    return isFinite(a / b)
}

export function unitsTotalFormula(a, b) {
    return divideNumbers(a, b)
}

export function divideNumbers(a, b) {
    try {
        if (HasValue(a, b)) {
            return a / b
        }
        else {
            return 0
        }
    }
    catch (e) /* istanbul ignore next */ {
        console.log(' Error in divideNumbers : ==> ' + e)
        return 0
    }
}

export function divideNumbersPercentage(a, b) {
    try {
        let value;
        if (HasValue(a, b)) {
            value = a / b
            value = Math.round(value)
            return value
        }
        else {
            return 0
        }
    }
    catch (e) /* istanbul ignore next */ {
        console.log(' Error in divideNumbers : ==> ' + e)
        return 0
    }
}

export function isUndefinedOrNull(val) {
    try {
        if (!val || val === null || val === undefined || val === 'undefined') {
            return ''
        }
        else {
            return val
        }
    }
    catch (e) /* istanbul ignore next */ {
        console.log(' Error in isUndefinedOrNull : ==> ' + e)
        return ''
    }
}

export function getFormattedNumber(inputVal, prefixSign = '', minFraction = 0, maxFraction = 0) {
    try {
        inputVal = isUndefinedOrNull(inputVal)
        inputVal = inputVal === '-' ? '' : inputVal
        inputVal = isNaN(inputVal) ? '' : inputVal

        if (inputVal !== '' && !isNaN(inputVal)) {
            let formattedNumber = Number(inputVal).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: minFraction, minimumFractionDigits: maxFraction })
            formattedNumber = prefixSign === '$' ? '$' + formattedNumber : formattedNumber
            formattedNumber = prefixSign === '%' ? formattedNumber + '%' : formattedNumber
            return formattedNumber
        }
        else {
            return '-'
        }
    } catch (e) /* istanbul ignore next */ {
        console.log('Error in get Formatted Number::: ' + e.message)
        return '-'
    }
}

export function sortArray(array, sortElement, direction) {
    return array.sort(function (a, b) {
        var sortElementA = a[sortElement]
        var sortElementB = b[sortElement]

        if (direction == 'asc') {
            if (sortElementA < sortElementB) {
                return -1
            }
            if (sortElementA > sortElementB) {
                return 1
            }
            return 0
        }
        if (direction == 'desc') {
            if (sortElementA > sortElementB) {
                return -1
            }
            if (sortElementA < sortElementB) {
                return 1
            }
            return 0
        }
    })
}

function getUnitMixRecords(propertyIdParam, propertyListParam, sourceParam = '') {
    unitMixRecords = []
    propertyList = propertyListParam
    propertyId = propertyIdParam
    try {

        propertyList.compsList.forEach(item => {
            if (propertyId === item.omniViewPropertyId && item.data.omniviewpropertyrent && item.data.omniviewpropertyrent.length) {
                if (sourceParam) {
                    unitMixRecords = [...item.data.omniviewpropertyrent.filter(x => x.source && x.source.toLowerCase() === sourceParam.toLowerCase())]
                } else {
                    unitMixRecords = [...item.data.omniviewpropertyrent]
                }
            }
        })

    } catch (e) {
        /* istanbul ignore next */
        console.log('Error in getUnitMixRecords::: ' + e.message)
    }

    return unitMixRecords
}

export function getUnitMixSource(propertyListParam, propertyIdParam) {

    propertyList = propertyListParam
    propertyId = propertyIdParam
    source = ''

    try {

        if (propertyList.compsList) {
            let prefIndex = propertyList.compsList.findIndex(x => x.omniViewPropertyId === propertyId)
            if (prefIndex !== -1 && propertyList.compsList[prefIndex].sourcePreference) {
                source = propertyList.compsList[prefIndex].sourcePreference
                return source
            }
        }

        getUnitMixRecords(propertyId, propertyList, '')

        var BCM = []
        var Axio = []
        var Yardi = []

        BCM = unitMixRecords.filter(function (val) {
            return val.source == 'BCM'
        });

        Axio = unitMixRecords.filter(function (val) {
            return val.source == 'Axio'
        });

        Yardi = unitMixRecords.filter(function (val) {
            return val.source == 'Yardi'
        });

        var tempBCM = BCM.length > 0 ? sortArray(BCM, 'date', 'desc')[0].date : "1800-01-01"
        var tempAxio = Axio.length > 0 ? sortArray(Axio, 'date', 'desc')[0].date : "1800-01-01"
        var tempYardi = Yardi.length > 0 ? sortArray(Yardi, 'date', 'desc')[0].date : "1800-01-01"

        tempBCM = tempBCM == "" ? "1800-01-01" : tempBCM
        tempAxio = tempAxio == "" ? "1800-01-01" : tempAxio
        tempYardi = tempYardi == "" ? "1800-01-01" : tempYardi

        if (tempBCM >= tempAxio && tempBCM >= tempYardi) {
            source = 'BCM'
        }
        else if (tempAxio >= tempYardi) {
            source = 'Axio'
        }
        else if (tempYardi != "1800-01-01" && tempYardi > tempAxio && tempYardi > tempBCM) {
            source = 'Yardi'
        }

        if (BCM.length == 0 && Axio.length == 0 && Yardi.length == 0) {
            source = ''
        }

    } catch (e) {
        /* istanbul ignore next */
        console.log('Error in getUnitMixRecords::: ' + e.message)
    }

    return source
}

export function getAnnualEffectiveRent(umRecords) {
    let returnVal = ''

    try {
        returnVal = multiplyTotal(multiplyTotal(umRecords.effectiveRent, umRecords.units), 12)
    } catch (error) {
        /* istanbul ignore next */
        console.log("error in getAnnualEffectiveRent ::: " + error.message)
    }

    return returnVal
}

export function rentCompAvgCalc(propertyListParam, setPropertyList) {
    propertyList = propertyListParam

    propertyList.compsList.forEach(item => {
        try {
            propertyId = item.omniViewPropertyId
            getUnitMixSource(propertyList, propertyId)
            getUnitMixRecords(propertyId, propertyList, source)

            for (let i = 0; i < unitMixRecords.length; i++) {
                unitMixRecords[i].annualEffectiveRent = getAnnualEffectiveRent(unitMixRecords[i])
            }

            if (unitMixRecords.length) {
                let totalUnitsBySource = totalDataCount('units', false)
                let sqftPerUnitBySource = unitsTotalFormula(multitotalDataCount('units', 'unitSize', '*', false), totalDataCountExcludingItem('units', false, 'unitSize'))
                let totalUnitSizeBySource = multitotalDataCount('units', 'unitSize', '*', false)
                let marketRentPerUnitBySource = unitsTotalFormula(multitotalDataCount('unitMarketRent', 'units', '*', false), totalDataCount('units', false))
                let effectivePerUnitBySource = unitsTotalFormula(multitotalDataCount('effectiveRent', 'units', '*', false), totalDataCount('units', false))
                let marketRentPerSFBySource = unitsTotalFormula(multitotalDataCount('unitMarketRent', 'units', '*', false), multitotalDataCount('units', 'unitSize', '*', false))
                let effectiveRentPerSFBySource = unitsTotalFormula(multitotalDataCount('effectiveRent', 'units', '*', false), multitotalDataCount('units', 'unitSize', '*', false))
                let monthlyMarketRent = totalDataCount('monthlyMarketRent', false)
                let monthlyEffectiveRent = totalDataCount('totalEffectiveRent', false)
                let annualMarketRent = totalDataCount('annualMarketRent', false)
                let annualEffectiveRent = totalDataCount('annualEffectiveRent', false)
                let totalBedsBySource = totalDataCount('beds', false)
                let minRentForAvg = isNaN(multitotalDataCount('minRent', 'units', '*', false)) ? '' : multitotalDataCount('minRent', 'units', '*', false)
                let maxRentForAvg = isNaN(multitotalDataCount('maxRent', 'units', '*', false)) ? '' : multitotalDataCount('maxRent', 'units', '*', false)
                let unitsForHighLow = totalDataCountExcludingItem('units', false, 'minRent')

                minRentForAvg = divideNumbers(multitotalDataCount('minRent', 'units', '*', false), unitsForHighLow)
                minRentForAvg = valueFormatter(minRentForAvg, 'currency')

                maxRentForAvg = divideNumbers(multitotalDataCount('maxRent', 'units', '*', false), unitsForHighLow)
                maxRentForAvg = valueFormatter(maxRentForAvg, 'currency')

                let highLow = `${minRentForAvg} - ${maxRentForAvg}`

                let marketRentPerBedBySource = 0, effectiveRentPerBedBySource = 0, totalBedssPerUnitBySource = 0

                if (isStudentHousingProperty(item.data.omniviewproperty[0])) {
                    marketRentPerBedBySource = unitsTotalFormula(multitotalDataCount('unitMarketRent', 'units', '*', false), totalDataCount('beds', false))
                    effectiveRentPerBedBySource = unitsTotalFormula(multitotalDataCount('effectiveRent', 'units', '*', false), totalDataCount('beds', false))
                    totalBedssPerUnitBySource = unitsTotalFormula(totalDataCount('beds', false), totalDataCount('units', false))
                    // console.log('totalBedssPerUnitBySource = ', totalBedssPerUnitBySource)
                }

                const index = propertyList.compsList.findIndex(x => x.omniViewPropertyId === propertyId)

                if (index !== -1) {

                    propertyList.compsList[index].data.omniviewproperty[0].totalUnitsBySource = totalUnitsBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].sqftPerUnitBySource = sqftPerUnitBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].totalUnitSizeBySource = totalUnitSizeBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].source = source
                    propertyList.compsList[index].data.omniviewproperty[0].marketRentPerUnitBySource = marketRentPerUnitBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].effectivePerUnitBySource = effectivePerUnitBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].marketRentPerSFBySource = marketRentPerSFBySource.toFixed(2)
                    propertyList.compsList[index].data.omniviewproperty[0].effectiveRentPerSFBySource = effectiveRentPerSFBySource.toFixed(2)
                    propertyList.compsList[index].data.omniviewproperty[0].monthlyMarketRent = monthlyMarketRent.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].monthlyEffectiveRent = monthlyEffectiveRent.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].annualMarketRent = annualMarketRent.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].annualEffectiveRent = annualEffectiveRent.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].totalBedsBySource = totalBedsBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].highLow = highLow

                    propertyList.compsList[index].data.omniviewproperty[0].marketRentPerBedBySource = marketRentPerBedBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].effectiveRentPerBedBySource = effectiveRentPerBedBySource.toFixed(0)
                    propertyList.compsList[index].data.omniviewproperty[0].totalBedssPerUnitBySource = totalBedssPerUnitBySource

                    let sourceLastModifiedDate = unitMixRecords[0].date
                    if (sourceLastModifiedDate) {
                        if (source !== 'BCM') {
                            sourceLastModifiedDate = getEndOfMonthDate(new Date(sourceLastModifiedDate));
                        }

                        var options = { year: 'numeric', month: 'short', day: 'numeric' }
                        sourceLastModifiedDate = new Intl.DateTimeFormat('en-US', options).format(new Date(sourceLastModifiedDate))
                    }

                    propertyList.compsList[index].data.omniviewproperty[0].sourceLastModifiedDate = sourceLastModifiedDate

                }

            }
        } catch (e) {
            /* istanbul ignore next */
            console.log('Error in rentCompAvgCalc::: ' + e.message)
        }
    })

    setPropertyList(propertyList)
}

export function getEndOfMonthDate(valDate) {
    let newDate = valDate
    try {
        newDate.setDate(1) // going to 1st of the month
        newDate.setHours(-1) // going to last hour before this date even started.
        return newDate;
    } catch (e) /* istanbul ignore next */ {
        console.log('Error in GetEndOfMonthDate::: ' + e.message);
        return valDate;
    }
}

export function getTotalAvgForSummaryComps(propertyListParam) {

    // console.log('propertyList:::', propertyList)
    propertyList = propertyListParam
    const { compsList, compType } = propertyListParam

    let returnVal = {}
    let rent = {
        totalUnits: 0, sqftPerUnit: 0, totalUnitSize: 0, source: '', marketRentPerUnit: 0,
        marketRentPerSF: 0, monthlyMarketRent: 0, annualMarketRent: 0, unitsCounts: 0, totalBeds: 0,
        bedsCount: 0, occupancy: 0, preleasing: 0, effectiveRentPerUnit: 0, effectiveRentPerSF: 0,
        totalBeds: 0, marketRentPerBed: 0, effectiveRentPerBed: 0
    }
    let unitsForOccupancy = 0, totalUnitsForSize = 0, totalUnitsForMR = 0, totalUnitsForER = 0, unitsForPreleasing = 0,
        totalBedsForMR = 0, totalBedsForER = 0

    let sales = {
        totalUnits: 0, sqftPerUnit: 0, totalUnitSize: 0, salePrice: 0, pricePerUnit: 0,
        pricePerSF: 0, CAP: 0, occupancy: 0, pricePerBed: 0, numberBeds: 0
    }

    let unitsForSalePrice = 0, unitsForCAP = 0, salePriceforBed = 0, numberBedsForSalePrice = 0

    try {
        compsList.forEach(val => {
            if (!val.isSubjectProperty && !val.excludeProperty) {

                let omniViewPropertyId = val.omniViewPropertyId
                let { omniviewproperty, omniviewpropertyrent } = val.data

                let lstOmniviewtransactionhistory = [...val.data.omniviewtransactionhistory]
                lstOmniviewtransactionhistory = lstOmniviewtransactionhistory.filter(x => x.transactionType && x.transactionType.toLowerCase() === 'sale')
                lstOmniviewtransactionhistory = [...sortArray(lstOmniviewtransactionhistory, 'saleDate', 'desc')]
                const omniviewtransactionhistory = lstOmniviewtransactionhistory.length ? lstOmniviewtransactionhistory[0] : {}

                let monthlyMarketRent = isUndefinedOrNull(omniviewproperty[0].monthlyMarketRent)
                let monthlyEffectiveRent = isUndefinedOrNull(omniviewproperty[0].effectivePerUnitBySource * omniviewproperty[0].totalUnitsBySource)

                source = getUnitMixSource(propertyList, omniViewPropertyId)
                unitMixRecords = getUnitMixRecords(omniViewPropertyId, propertyList)

                let totalUnitsBySource = isUndefinedOrNull(omniviewproperty[0].totalUnitsBySource)
                if (totalUnitsBySource !== '' && totalUnitsBySource !== NaN && !isNaN(totalUnitsBySource)) {
                    rent.unitsCounts = 1 + +rent.unitsCounts
                    rent.totalUnits += +omniviewproperty[0].totalUnitsBySource
                }

                if (isStudentHousingProperty(omniviewproperty[0]) || omniviewproperty[0].omniViewPropertyType === 'Health Care') {
                    let totalBedsBySource = isUndefinedOrNull(omniviewproperty[0].totalBedsBySource)
                    if (totalBedsBySource !== '' && totalBedsBySource !== NaN && !isNaN(totalBedsBySource)) {
                        rent.bedsCount = 1 + +rent.bedsCount
                        rent.totalBeds += +totalBedsBySource
                    }

                    if (isUndefinedOrNull(omniviewproperty[0].preleasing) != '') {
                        rent.preleasing = rent.preleasing + (parseFloat(omniviewproperty[0].preleasing) * parseFloat(omniviewproperty[0].propertyTotalUnits))
                        unitsForPreleasing += +omniviewproperty[0].propertyTotalUnits
                    }

                    if (monthlyMarketRent && monthlyMarketRent !== 0 && monthlyMarketRent !== '0' && totalBedsBySource && totalBedsBySource !== NaN && !isNaN(totalBedsBySource)) {
                        rent.marketRentPerBed += +monthlyMarketRent
                        totalBedsForMR += +omniviewproperty[0].totalBedsBySource
                    }

                    if (monthlyEffectiveRent && !isNaN(monthlyEffectiveRent) && monthlyEffectiveRent !== 0 && monthlyEffectiveRent !== '0' && totalBedsBySource && totalBedsBySource !== NaN && !isNaN(totalBedsBySource)) {
                        rent.effectiveRentPerBed += +monthlyEffectiveRent
                        totalBedsForER += +omniviewproperty[0].totalBedsBySource
                    }
                }

                let totalUnitSizeBySource = isUndefinedOrNull(omniviewproperty[0].totalUnitSizeBySource)
                if (totalUnitSizeBySource !== '' && totalUnitSizeBySource !== 0 && totalUnitSizeBySource !== NaN && !isNaN(totalUnitSizeBySource)) {
                    rent.totalUnitSize += +totalUnitSizeBySource
                    totalUnitsForSize += +omniviewproperty[0].totalUnitsBySource
                }

                if (isUndefinedOrNull(omniviewproperty[0].occupancy) != '') {
                    rent.occupancy = rent.occupancy + (parseFloat(omniviewproperty[0].occupancy) * parseFloat(omniviewproperty[0].propertyTotalUnits))
                    unitsForOccupancy += +omniviewproperty[0].propertyTotalUnits
                }

                if (monthlyMarketRent && monthlyMarketRent !== 0 && monthlyMarketRent !== '0') {
                    rent.marketRentPerUnit += +monthlyMarketRent
                    totalUnitsForMR += +omniviewproperty[0].totalUnitsBySource
                }

                if (monthlyEffectiveRent && !isNaN(monthlyEffectiveRent) && monthlyEffectiveRent !== 0 && monthlyEffectiveRent !== '0') {
                    rent.effectiveRentPerUnit += +monthlyEffectiveRent
                    totalUnitsForER += +omniviewproperty[0].totalUnitsBySource
                }

                if (lstOmniviewtransactionhistory.length > 0) {
                    //omniviewtransactionhistory
                    let totalUnits = isUndefinedOrNull(omniviewtransactionhistory.numberUnits)
                    let totalUnitSize = isUndefinedOrNull(omniviewtransactionhistory.squareFeet)
                    let salePrice = isUndefinedOrNull(omniviewtransactionhistory.salePrice)
                    // let pricePerUnit = isUndefinedOrNull(omniviewtransactionhistory.transactionHistoryPricePerUnit)
                    // let pricePerSF = isUndefinedOrNull(omniviewtransactionhistory.pricePerSf)
                    let CAP = isUndefinedOrNull(omniviewtransactionhistory.transactionHistoryCapRate)
                    let numberBeds = isUndefinedOrNull(omniviewtransactionhistory.numberBeds)

                    // console.log(omniviewproperty[0].propertyName, '::::', totalUnitSizeBySource)

                    if (totalUnits && totalUnits !== 0 && totalUnits !== '0') {
                        sales.totalUnits += +totalUnits
                    }

                    if (totalUnitSize && totalUnitSize !== 0 && totalUnitSize !== '0') {
                        sales.totalUnitSize += +totalUnitSize
                    }

                    if (salePrice && salePrice !== 0 && salePrice !== '0') {
                        sales.salePrice += +multiplyTotal(salePrice, totalUnits)
                        unitsForSalePrice += +totalUnits
                        sales.pricePerUnit += +salePrice
                        sales.pricePerSF += +salePrice
                    }

                    if (CAP && CAP !== 0 && CAP !== '0') {
                        // console.log(omniviewproperty[0].propertyName, '====', multiplyTotal(CAP, totalUnits))
                        sales.CAP += +multiplyTotal(CAP, totalUnits)
                        unitsForCAP += +totalUnits
                    }

                    if ((isStudentHousingProperty(omniviewproperty[0]) || isHealthCareProperty(omniviewproperty[0])) && numberBeds) {
                        sales.numberBeds += +numberBeds
                        if (salePrice) {
                            salePriceforBed += +multiplyTotal(salePrice, numberBeds)
                        }
                    }


                }

            }
        })

        rent.sqftPerUnit = divideNumbers(rent.totalUnitSize, totalUnitsForSize)
        rent.occupancy = divideNumbersPercentage(rent.occupancy, unitsForOccupancy)
        rent.preleasing = divideNumbers(rent.preleasing, unitsForPreleasing)

        rent.marketRentPerSF = divideNumbers(rent.marketRentPerUnit, rent.totalUnitSize)

        rent.effectiveRentPerSF = divideNumbers(rent.effectiveRentPerUnit, rent.totalUnitSize)

        rent.marketRentPerUnit = divideNumbers(rent.marketRentPerUnit, totalUnitsForMR)
        rent.marketRentPerUnit = rent.marketRentPerUnit.toFixed(0)

        rent.effectiveRentPerUnit = divideNumbers(rent.effectiveRentPerUnit, totalUnitsForER)
        rent.effectiveRentPerUnit = rent.effectiveRentPerUnit.toFixed(0)

        rent.marketRentPerBed = divideNumbers(rent.marketRentPerBed, totalBedsForMR)
        rent.marketRentPerBed = rent.marketRentPerBed.toFixed(0)

        rent.effectiveRentPerBed = divideNumbers(rent.effectiveRentPerBed, totalBedsForER)
        rent.effectiveRentPerBed = rent.effectiveRentPerBed.toFixed(0)

        sales.occupancy = rent.occupancy
        sales.salePrice = divideNumbers(sales.salePrice, unitsForSalePrice)
        sales.salePrice = sales.salePrice.toFixed(0)

        sales.pricePerUnit = divideNumbers(sales.pricePerUnit, unitsForSalePrice)
        sales.pricePerUnit = sales.pricePerUnit.toFixed(0)

        sales.pricePerSF = divideNumbers(sales.pricePerSF, sales.totalUnitSize)

        sales.CAP = divideNumbers(sales.CAP, unitsForCAP)

        sales.pricePerBed = divideNumbers(salePriceforBed, sales.numberBeds)

    } catch (e) /* istanbul ignore next */ {
        console.log('Error in get Total Avg For Summary Comps::: ' + e.message)
        returnVal = { rent, sales }
    }

    returnVal = { rent, sales }
    // console.log('rent===========', rent)
    return returnVal
}

export function valueFormatter(inputVal, type = 'text') {
    let returnVal = inputVal ? inputVal : ''

    try {
        returnVal = returnVal.toString()

        switch (type) {
            case 'number':
                returnVal = getFormattedNumber(returnVal)
                break
            case 'percent':
                // returnVal = getFormattedNumber(returnVal, '%')
                if (returnVal.includes('.')) {
                    returnVal = getFormattedNumber(returnVal, '%', '2', '2')
                } else {
                    returnVal = getFormattedNumber(returnVal, '%')
                }
                break
            case 'currency':
                if (returnVal.includes('.')) {
                    returnVal = getFormattedNumber(returnVal, '$', '2', '2')
                } else {
                    returnVal = getFormattedNumber(returnVal, '$')
                }
                break
            default: break
        }

        returnVal = !returnVal ? '-' : returnVal

    } catch (error) {
        /* istanbul ignore next */
        console.log("error in valueFormatter ::: ", inputVal, '===', error.message)
    }

    return returnVal

}

export function multiplyTotal(item1, item2) {
    return !(parseFloat(item1) * parseFloat(item2)) ? 0 : parseFloat(item1) * parseFloat(item2);
}

export function sortPropertyList(newPropertyList, sortField, direction) {
    propertyList = { ...newPropertyList }
    // let { fieldName, dataObj } = sortField omniViewPropertyId omniViewPropertyId

    let omniviewproperties = [], omniviewtransactionhistory = [], compsList = []
    propertyList.compsList.forEach(val => {

        omniviewproperties.push(val.data.omniviewproperty[0])

        let lstOmniviewtransactionhistory = [...val.data.omniviewtransactionhistory]
        lstOmniviewtransactionhistory = lstOmniviewtransactionhistory.filter(x => x.transactionType && x.transactionType.toLowerCase() === 'sale')
        if (lstOmniviewtransactionhistory.length > 0) {
            lstOmniviewtransactionhistory = [...sortArray(lstOmniviewtransactionhistory, 'saleDate', 'desc')]
            omniviewtransactionhistory.push(lstOmniviewtransactionhistory[0])
        }
        else {
            omniviewtransactionhistory.push({ 'omniViewPropertyId': val.omniViewPropertyId })
        }
    })

    if (sortField.dataObj === 'omniviewproperty') {
        omniviewproperties = [...sortNumberArray(omniviewproperties, sortField.fieldName, direction)]
        // omniviewproperties.forEach(val => {
        //     console.log(sortField.fieldName, '====', Number(val[sortField.fieldName]))
        // })

        omniviewproperties.forEach(function (key) {
            var found = false;
            omniviewproperties = propertyList.compsList.filter(function (item) {
                if (!found && item.omniViewPropertyId == key.omniViewPropertyId) {
                    compsList.push(item);
                    found = true;
                    return false;
                } else
                    return true;
            })
        })
    }

    if (sortField.dataObj === 'omniviewtransactionhistory') {
        omniviewtransactionhistory = [...sortNumberArray(omniviewtransactionhistory, sortField.fieldName, direction)]
        if (sortField.type === 'date') {
            omniviewtransactionhistory = [...sortArray(omniviewtransactionhistory, sortField.fieldName, direction)]
        }
        // omniviewtransactionhistory.forEach(val => {
        //     console.log(sortField.fieldName, '====', val[sortField.fieldName])
        // })

        omniviewtransactionhistory.forEach(function (key) {
            var found = false;
            omniviewtransactionhistory = propertyList.compsList.filter(function (item) {
                if (!found && item.omniViewPropertyId == key.omniViewPropertyId) {
                    compsList.push(item);
                    found = true;
                    return false;
                } else
                    return true;
            })
        })
    }

    let subjectProperties = compsList.filter(x => x.isSubjectProperty)
    let nonSubjectProperties = compsList.filter(x => !x.isSubjectProperty)

    let rank = subjectProperties.length

    nonSubjectProperties.forEach(val => {
        rank += 1
        val.rank = rank
    })

    compsList = [...subjectProperties, ...nonSubjectProperties]

    propertyList.compsList = [...compsList]
    return propertyList
}

export function sortNumberArray(array, sortElement, direction) {
    return array.sort(function (a, b) {
        var sortElementA = a[sortElement]
        var sortElementB = b[sortElement]

        if (direction == 'asc') {
            return sortElementA - sortElementB
        }
        if (direction == 'desc') {
            return sortElementB - sortElementA
        }
    })
}

export function updatePropertyRank(newPropertyList) {
    let fieldsToUpdate = []
    let updatedCompsList = []

    newPropertyList.compsList.forEach(item => {
        updatedCompsList.push({
            "omniViewCompsListId": item.omniViewCompsListId,
            "omniViewPropertyId": item.omniViewPropertyId,
            "isSubjectProperty": item.isSubjectProperty,
            "rank": item.rank,
            "action": "modify"
        })
    })

    fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: newPropertyList.omniViewPropertyListId })
    fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: newPropertyList.polarisPropertySearchCriteriaId })
    fieldsToUpdate.push({ key: 'compsList', value: updatedCompsList })
    // fieldsToUpdate.push({ key: 'compType', value: newPropertyList.compType })

    const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
    return updatePropertyListObj.update()
}


export function getRentViewSettings(propertyListParam) {
    let returnVal = []

    if (propertyListParam.average) {
        returnVal.push('market rent')
    }

    if (propertyListParam.highLow) {
        returnVal.push('high low')
    }

    if (propertyListParam.effectiveRents) {
        returnVal.push('effective rent')
    }

    return returnVal
}

export function getFloorPlanColumns(propertyListParam, allColumns) {

    try {

        let forColumns = []
        forColumns = getRentViewSettings(propertyListParam)
        if (forColumns.length === 0) {
            forColumns.push('market rent')
        }
        return allColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))

    } catch (e) {
        return allColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))
    }
}

export function getSummaryColumnsList(propertyListParam, allColumns) {

    try {

        let forColumns = []
        const compType = propertyListParam.compType ? propertyListParam.compType.toLowerCase() : 'rent'

        if (isHealthCareList(propertyListParam)) {
            forColumns.push('health care')
            if (compType === 'sales') {
                forColumns.push('health care sales')
            }
            else {
                forColumns.push('health care rent')
            }

        }
        else if (isStudentHousingList(propertyListParam)) {

            forColumns.push(`student housing ${compType}`)

            if (compType !== 'sales') {
                let tempforColumns = getRentViewSettings(propertyListParam)

                tempforColumns.forEach(item => {
                    let newItem = item === 'high low' ? 'market rent' : item
                    forColumns.push(`student housing ${newItem}`)
                })
            }

        }
        else {
            if (compType === 'rent') {
                forColumns = getRentViewSettings(propertyListParam)
                if (forColumns.length === 0) {
                    forColumns.push('market rent')
                }
            } else {
                forColumns.push(compType)
            }
        }

        return allColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))
    } catch (e) {
        return allColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))
    }
}

export function isStudentHousingList(propertyListParam) {
    let returnVal = false
    try {

        propertyListParam.compsList.forEach(item => {
            if (item.data.omniviewproperty[0].omniViewPropertyType === 'Student Housing' && item.isSubjectProperty) {
                returnVal = true
            }
        })

    } catch (e) {
        console.log('error in isStudentHousingList = ', e)
    }
    return returnVal
}

export function isHealthCareList(propertyListParam) {
    let returnVal = false
    try {

        propertyListParam.compsList.forEach(item => {
            if (item.data.omniviewproperty[0].omniViewPropertyType === 'Health Care' && item.isSubjectProperty) {
                returnVal = true
            }
        })

    } catch (e) {
        console.log('error in isHealthCareList = ', e)
    }
    return returnVal
}

export function isStudentHousingProperty(property) {
    let returnVal = false
    try {

        if (property.omniViewPropertyType === 'Student Housing') {
            returnVal = true
        }

    } catch (e) {
        console.log('error in isStudentHousingProperty = ', e)
    }
    return returnVal
}

export function isHealthCareProperty(property) {
    let returnVal = false
    try {

        if (property.omniViewPropertyType === 'Health Care') {
            returnVal = true
        }

    } catch (e) {
        console.log('error in isHealthCareProperty = ', e)
    }
    return returnVal
}

export function determineDistanceFromSubject(compsList) {
    try {
        let subjectProperties = compsList.filter(x => x.isSubjectProperty)
        let nonSubjectProperties = compsList.filter(x => !x.isSubjectProperty)

        subjectProperties = subjectProperties.sort(function (a, b) {
            return a.rank - b.rank;
        })

        nonSubjectProperties.forEach(item => {
            item.data.omniviewproperty[0].distanceFromSubject = ''
        })

        subjectProperties.forEach(item => {
            item.data.omniviewproperty[0].distanceFromSubject = ''
        })

        if (subjectProperties.length && subjectProperties[0].data.propertyLocation) {
            // console.log('in subjectProperties :: ')
            let subjectAddress = subjectProperties[0].data.propertyLocation

            nonSubjectProperties.forEach(item => {
                let distanceFromSubject = ''

                if (subjectAddress && item.data.propertyLocation) {
                    // console.log('in propertyLocation :: ')
                    let subjectLocation = subjectAddress.split(',')
                    let propertyLocation = item.data.propertyLocation.split(',')
                    distanceFromSubject = distance(subjectLocation[1], subjectLocation[0], propertyLocation[1], propertyLocation[0])
                }

                item.data.omniviewproperty[0].distanceFromSubject = distanceFromSubject
            })
        }
    } catch (e) {
        console.log('error in determineDistanceFromSubject :: ', e.message)
    }

    return compsList
}

export function sortUnitMixData(unitMixData, sortFieldName, order) {
    let result = unitMixData

    try {
        if (sortFieldName == 'unitType') {
            if (order === 'asc') {
                result = result.sort((a, b) => a.unitType.localeCompare(b.unitType) || a.unitMarketRent - b.unitMarketRent);
            } else {
                result = result.sort((a, b) => b.unitType.localeCompare(a.unitType) || b.unitMarketRent - a.unitMarketRent);
            }
        }
        else if (sortFieldName == 'unitSize') {
            if (order === 'asc') {
                result.sort((a, b) => a.unitSize - b.unitSize || a.unitMarketRent - b.unitMarketRent);
            } else {
                result.sort((a, b) => b.unitSize - a.unitSize || b.unitMarketRent - a.unitMarketRent);
            }
        }
        else if (sortFieldName === 'highLow') {
            result = result.sort(function (a, b) {
                if (order === 'asc') {
                    return a['minRent'] - b['minRent'] || a['maxRent'] - b['maxRent'];
                } else if (order === 'desc') {
                    return b['minRent'] - a['minRent'] || b['maxRent'] - a['maxRent'];
                }
            });
        } else {
            result = result.sort(function (a, b) {
                if (order === 'asc') {
                    return a[sortFieldName] - b[sortFieldName]
                } else if (order === 'desc') {
                    return b[sortFieldName] - a[sortFieldName]
                }
            });
        }

    } catch (error) {
        console.log(' error in sortUnitMixData :: ', error)
    }
    // updateSortPreference(sortFieldName, order)

    return result
}


export function getPropertyTypeColor(propertyType) {
    try {

        const colors = {
            'Hospitality': '#161616',
            'Health Care': '#61818e',
            'Land': '#959884',
            'Student Housing': '#8b5783',
            'Industrial': '#1e4280',
            'Other': '#a4551f',
            'Office': '#ab1d27',
            'Retail': '#b99334',
            'Multifamily': '#658d34',
        }

        return colors[propertyType]

    } catch (e) {
        console.log('Error in getPropertyTypeColor::: ', e)
    }
}

export async function readyToUpdate() {
    let returnVal = true

    try {
        let messageId = localStorage.getItem("messageId")

        if (messageId) {
            messageId = JSON.parse(messageId)
            var startDate = new Date(messageId.timestamp)
            var endDate = new Date()
            var timeDiff = (endDate.getTime() - startDate.getTime()) / (1000 * 60)

            if (timeDiff > 5) {
                localStorage.setItem("messageId", '')
            } else {
                let response = await getMessageStatus(`messageId=${messageId.value}`)
                // console.log(' readyToUpdate :: ', response)
                if (response && response.status === 200) {
                    let message = response && response.data ? response.data.message : { 'status': '' }
                    // returnVal = message.status
                    if (message.status !== 'pending') {
                        localStorage.setItem("messageId", '')
                    } else {
                        returnVal = false
                    }
                }
            }
        }
    } catch (error) {
        console.log(' error in readyToUpdate :: ', error)
    }

    return returnVal
}

export async function pendingResponse() {
    return { status: 100, data: { message: 'Your previous request is not yet completed. Please wait for some time or contact Production support.' } }
}


// export function isJson(str) {
//     try {
//         JSON.parse(str);
//     } catch (e) {
//         return false;
//     }
//     return true;
// }